export enum SEARCHTEXT {
    SEARCH_BY_ID = `Search by Member ID instead.`,
    SEARCH_BY_INFO = `Search by Member's information instead.`
}